import { createSlice } from "@reduxjs/toolkit";
import pagesState from "../../../constants/pages/pagesState";

// Create a Redux slice for the 'Pages' portion of the state
export const pagesSlice = createSlice({
  name: "pages", // The name of the slice
  initialState: pagesState, // Initial state for Pages
  reducers: {
    // Set page data action
    setPageData: (state, action) => {
      state.data = action.payload;
    },
    // Set pages
    setPages: (state, action) => {
      state.data.pages = action.payload;
    },
    // Set pages length
    setPagesLength: (state, action) => {
      state.data.totalLength = action.payload;
    },
    // Set page number action
    setPageNumber: (state, action) => {
      state.data.page = action.payload;
    },
    // Set search term action
    setPageSearchTerm: (state, action) => {
      state.data.search = action.payload;
    },
    // Set domain ids action
    setPagesDomainIds: (state, action) => {
      state.data.domainIds = action.payload;
    },
  },
});

// Destructure the action creators for easy access
export const {
  setPageData,
  setPages,
  setPagesLength,
  setPageNumber,
  setPageSearchTerm,
  setPagesDomainIds,
} = pagesSlice.actions;

// Export the reducer
export default pagesSlice.reducer;
